<template>
  <div>
    <h1 class="item-title">{{ $t('components_contract_end_suspend_use.he_tong_xin_xi') }}</h1>
    <div class="item-title-info">
      <el-row>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_end_suspend_use.he_tong_lei_xing') }}:</span>
          <span class="value">{{ getDicValue('crm_contract_type', detail.contractType) }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_end_suspend_use.he_tong_bian_hao') }}:</span>
          <span class="value">{{ detail.contractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_end_suspend_use.sghth') }}:</span>
          <span class="value">{{ detail.customContractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_end_suspend_use.jfsqdbgs') }}:</span>
          <span class="value">{{ detail.partyAName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_end_suspend_use.yi_fang') }}:</span>
          <span class="value">{{ detail.customerName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_end_suspend_use.shou_hou_gong_si') }}:</span>
          <span class="value">{{ detail.afterServiceName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_end_suspend_use.xiang_mu_ming_cheng') }}:</span>
          <span class="value">{{ detail.locationName }}</span>
        </el-col>
        <el-col :span="16">
          <span class="label">{{ $t('components_contract_end_suspend_use.shi_yong_di_dian') }}:</span>
          <span class="value">{{ detail.country || '' }}{{ detail.province || '' }}{{ detail.city || '' }}{{ detail.useAddress }}</span>
        </el-col>
      </el-row>
    </div>
    <h1 class="item-title">{{ $t('components_contract_end_suspend_use.shen_qing_xin_xi') }}</h1>
    <div style="margin-bottom: 30px">
      <custom-table ref="customTb1" type="checkbox" v-model="selectDevice" :column="tableColumn" :data="dataList" @filter="filterChange" @sort="sortChange" :filterArr="['suspendUseDate']">
        <template slot="suspendUseDate" slot-scope="scope">
          <custom-date-picker
            :disabled="model.type === 'watch'"
            style="width: 90%"
            v-model="scope.row.startPauseDate"
            align="right"
            type="date"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="{
              disabledDate(time) {
                return time.getTime() < Date.now() || time.getTime() > new Date(`${scope.row.endRentDate}Z`).getTime();
              }
            }"
          ></custom-date-picker>
        </template>
      </custom-table>
    </div>
    <el-form :model="form" ref="form" label-width="auto" :rules="rules">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('components_contract_end_suspend_use.shen_qing_miao_shu')" prop="changeDesc">
            <el-input :disabled="model.type === 'watch'" type="textarea" :rows="4" :placeholder="$t('components_contract_end_suspend_use.qstxsqsm')" v-model="form.changeDesc" style="width: 626px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '' // 新增时为orderId, 编辑查看时为changeId
        };
      }
    }
  },
  data() {
    return {
      tableCode: 'suspendUse',
      detail: {},
      dataList: [],
      selectDevice: [],

      form: {
        changeOrderId: '',
        orderId: '',
        changeDesc: '',
        changeOrderDevices: []
      },
    };
  },
  computed: {
    rules() {
      return {
        changeDesc: [{ required: true, message: this.$t('Common.com_required') }, { max: 200, message: this.$t('Common.com_rules_length_max', [200]), }]
      };
    },
    isSubmit: vm => !vm.selectDevice.length
  },
  mounted() {
    this.initDialog();
    this.getTableColumn();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.orderId = this.model.changeId;
        this.getOrderInfo();
        this.getDeviceList();
      }
      if (this.model.type === 'edit') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.getDeviceList(list);
        });
      }
      if (this.model.type === 'watch') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.dataList = list;
          this.dataList.forEach((item) => {
            item.isExists = true;
            this.$refs.customTb1.$emit('toggleRowSelection', item, true);
          });
        });
      }
    },
    // 订单信息
    getOrderInfo: function () {
      this.$getJSON(apis.ChangeOrderInfo, {
        orderId: this.model.changeId
      }).then((res) => {
        this.detail = res.data;
      });
    },
    // 获取变更详情
    getChangeDetail: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.OrderChangeInfo, {
        changeOrderId: this.model.changeId
      }).then((res) => {
        this.detail = res.data;
        this.form.orderId = res.data.orderId;
        this.form.changeDesc = res.data.changeDesc;
        cb(res.data.changeDeviceInfos);
      });
    },
    // 合同设备列表
    getDeviceList: function (selectDevice) {
      this.$getJSON(apis.OrderChangeDeviceList, {
        orderId: this.form.orderId,
        bizState: ['22']
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.startPauseDate = '';
        });
        this.dataList = list;
        if (selectDevice) {
          this.dataList.forEach((item) => {
            const row = selectDevice.find(t => t.orderDeviceId === item.orderDeviceId);
            if (row) {
              item.startPauseDate = row.startPauseDate;
              this.$refs.customTb1.$emit('toggleRowSelection', item, true);
            }
          });
        }
      });
    },
    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.selectDevice.length) {
          this.$message.error(this.$t('components_contract_end_suspend_use.qing_xuan_ze_she_bei'));
          return;
        }
        const hasEmpty = this.selectDevice.find(t => !t.startPauseDate);
        if (hasEmpty) {
          this.$message.error(this.$t('components_contract_end_suspend_use.qxzztsysj'));
          return;
        }
        this.form.isStartApprove = approve || 0;
        this.form.changeOrderDevices = this.selectDevice;
        this.$postJSON(apis.PauseUseSave, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.$emit('success');
        });
      });
    }
  }
};
</script>

<style lang="scss"></style>
